import { Box, Card, CardContent, Stack, Typography, Link } from '@mui/material'
import { format } from 'date-fns'
import { useNavigation } from 'src/hooks'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

interface LabResultItemProps {
    orderDate: Date | null | undefined
    test: string
    requester: string
    labPerformer: string
    id: string
}

/**
 * Displays a single lab result item in a card format
 * Shows the order date, test name, requesting doctor, and lab performer
 */
export const LabResultItem = ({
    orderDate,
    test,
    requester,
    labPerformer,
    id
}: LabResultItemProps) => {
    const { navigate } = useNavigation()

    return (
        <Link
            component="div"
            onClick={() => navigate(`/your-care/lab-results/${id}`)}
            sx={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'block',
                mt: 2
            }}
        >
            <Card
                elevation={0}
                sx={{
                    'border': 1,
                    'borderColor': 'divider',
                    'cursor': 'pointer',
                    '&:hover': {
                        backgroundColor: 'action.hover'
                    }
                }}
            >
                <CardContent sx={{ px: 4 }}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Box>
                            <Box sx={{ mb: 1 }}>
                                {/* Order date */}
                                <Typography
                                    variant="overline"
                                    color="text.secondary"
                                >
                                    {orderDate
                                        ? format(
                                              orderDate,
                                              'MMMM d, yyyy'
                                          ).toUpperCase()
                                        : ''}
                                </Typography>

                                {/* Test name / title */}
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: '1.5rem',
                                        lineHeight: '32px'
                                    }}
                                >
                                    {test}
                                </Typography>
                            </Box>

                            <Box>
                                {/* Requesting doctor */}
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {requester}
                                </Typography>

                                {/* Lab performer */}
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {labPerformer}
                                </Typography>
                            </Box>
                        </Box>

                        <ArrowForwardIcon color="action" />
                    </Stack>
                </CardContent>
            </Card>
        </Link>
    )
}
